import { Box } from '@mui/material';
import HeaderThemes from './Themes';

function HeaderButtons() {
  return (
    <Box sx={{ mr: 1 }}>
      <Box sx={{ mx: 0.5 }} component="span">
        <HeaderThemes />
      </Box>
    </Box>
  );
}

export default HeaderButtons;
